export const AppVersion = '1.0.0';
